/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Trigger_Task_CanceledInputs */

const en_automation_trigger_task_canceled = /** @type {(inputs: Automation_Trigger_Task_CanceledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} canceled`)
};

const pt_br2_automation_trigger_task_canceled = /** @type {(inputs: Automation_Trigger_Task_CanceledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} cancelada`)
};

/**
* | output |
* | --- |
* | "{task} canceled" |
*
* @param {Automation_Trigger_Task_CanceledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_canceled = /** @type {((inputs: Automation_Trigger_Task_CanceledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_CanceledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_canceled(inputs)
	return pt_br2_automation_trigger_task_canceled(inputs)
});